import { Reveal, SectionHeading } from "@/components/shared";
import { CASES } from "@/data/content";

function CaseRow({ label, text, last = false }) {
  return (
    <div className={`flex gap-4 ${!last ? "pb-4" : ""}`}>
      <span className="mt-0.5 shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{label}</span>
      <p className="text-sm leading-relaxed text-slate-300">{text}</p>
    </div>
  );
}

export default function Cases() {
  return (
    <section className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Cases de sucesso"
          title={<>Resultados que <span className="text-gold-grad">falam por nós.</span></>}
          sub="Trabalhos realizados em edificações e condomínios — do desafio ao resultado comprovado."
        />
        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {CASES.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.1} className="h-full">
              <article
                data-testid={`case-card-${i}`}
                className="group flex h-full flex-col border border-white/[0.07] bg-navy-800/40 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/30"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={c.image}
                    alt={`Case ${c.name} — Realiza Engenharia`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-950/90 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3 className="font-display text-xl font-bold uppercase tracking-wide text-white">{c.name}</h3>
                    <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold/90">{c.location}</p>
                  </div>
                </div>
                <div className="flex-1 space-y-4 p-6">
                  <CaseRow label="Desafio →" text={c.challenge} />
                  <CaseRow label="Solução →" text={c.solution} />
                  <div className="border-t border-white/5 pt-4">
                    <CaseRow label="Resultado →" text={c.result} last />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
